<template>
	<nav class="navbar" role="navigation" aria-label="main navigation" v-if="useMobile">
		<div class="navbar-brand">
			<router-link tag="a" class="navbar-item" to="/">
				<img src="../../assets/img/VIP Racing Logo Long Scaled.png">
			</router-link>
			<a role="button" @click="showNav = !showNav" class="navbar-burger burger" :class="{ 'is-active' : showNav }" aria-label="menu" aria-expanded="false">
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>
		</div>
		<div class="navbar-menu" :class="{ 'is-active' : showNav }">
			<div class="navbar-start">
				<div class="menu-item">
					<div>
						<router-link tag="a" to="/next-events">Next Events</router-link>
					</div>
				</div>
				<div class="menu-item" v-if="totalHorseEvents != 0">
					<div>
						<router-link tag="a" to="/categories/vip-horse">VIP Horse Racing <span class="num-events">{{ totalHorseEvents }}</span></router-link>
						<span class="fas fa-angle-down" @click="showHorseRacing = !showHorseRacing" :class="{ 'is-active' : showHorseRacing }"></span>
					</div>
					<ul :class="{ 'is-active' : showHorseRacing }">
						<li v-for="(meeting, key) in menuData.categories['vip-horse'].events" :key="key">
							<div>
								<router-link :to="'/categories/vip-horse/' + key">{{ meeting.name }}</router-link>
								<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
							</div>
							<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
								<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-horse/' + key + '/' + event.ID">
									<div>
										<a>{{ event.name }}</a>
									</div>
								</router-link>
							</ul>
						</li>
					</ul>
				</div>
				<div class="menu-item" v-if="totalGreyhoundEvents != 0">
					<div>
						<router-link tag="a" to="/categories/vip-greyhound">VIP Greyhounds <span class="num-events">{{ totalGreyhoundEvents }}</span></router-link>
						<span class="fas fa-angle-down" @click="showGreyhounds = !showGreyhounds" :class="{ 'is-active' : showGreyhounds }"></span>
					</div>
					<ul :class="{ 'is-active' : showGreyhounds }">
						<li v-for="(meeting, key) in menuData.categories['vip-greyhound']['events']" :key="key">
							<div>
								<router-link tag="a" :to="'/categories/vip-greyhound/' + key">{{ meeting.name }}</router-link>
								<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
							</div>
							<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
								<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-greyhound/' + key + '/' + event.ID">
									<div>
										<a>{{ event.name }}</a>
									</div>
								</router-link>
							</ul>
						</li>
					</ul>
				</div>
				<div class="menu-item" v-if="totalCyclingEvents != 0">
					<div>
						<router-link tag="a" to="/categories/vip-cycling">VIP Cycling <span class="num-events">{{ totalCyclingEvents }}</span></router-link>
						<span class="fas fa-angle-down" @click="showCycling = !showCycling" :class="{ 'is-active' : showCycling }"></span>
					</div>
					<ul :class="{ 'is-active' : showCycling }">
						<li v-for="(meeting, key) in menuData.categories['vip-cycling']['events']" :key="key">
							<div>
								<router-link tag="a"  :to="'/categories/vip-cycling/' + key">{{ meeting.name }}</router-link>
								<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
							</div>
							<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
								<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-cycling/' + key + '/' + event.ID">
									<div>
										<a>{{ event.name }}</a>
									</div>
								</router-link>
							</ul>
						</li>
					</ul>
				</div>
				<div class="menu-item" v-if="totalMotorEvents != 0">
					<div>
						<router-link tag="a" to="/categories/vip-motor-racing">VIP Motor Racing <span class="num-events">{{ totalMotorEvents }}</span></router-link>
						<span class="fas fa-angle-down" @click="showMotorRacing = !showMotorRacing" :class="{ 'is-active' : showMotorRacing }"></span>
					</div>
					<ul :class="{ 'is-active' : showMotorRacing }">
						<li v-for="(meeting, key) in menuData.categories['vip-motor-racing']['events']" :key="key">
							<div>
								<router-link tag="a" :to="'/categories/vip-motor-racing/' + key">{{ meeting.name }}</router-link>
								<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
							</div>
							<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
								<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-motor-racing/' + key + '/' + event.ID">
									<div>
										<a>{{ event.name }}</a>
									</div>
								</router-link>
							</ul>
						</li>
					</ul>
				</div>
				<div class="menu-item" v-if="totalSpeedwayEvents != 0">
					<div>
						<router-link tag="a" to="/categories/vip-speedway">VIP Speedway <span class="num-events">{{ totalSpeedwayEvents }}</span></router-link>
						<span class="fas fa-angle-down" @click="showSpeedway = !showSpeedway" :class="{ 'is-active' : showSpeedway }"></span>
					</div>
					<ul :class="{ 'is-active' : showSpeedway }">
						<li v-for="(meeting, key) in menuData.categories['vip-speedway']['events']" :key="key">
							<div>
								<router-link tag="a" :to="'/categories/vip-speedway/' + key">{{ meeting.name }}</router-link>
								<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
							</div>
							<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
								<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-speedway/' + key + '/' + event.ID">
									<div>
										<a>{{ event.name }}</a>
									</div>
								</router-link>
							</ul>
						</li>
					</ul>
				</div>
				<div class="menu-item">
					<div>
						<router-link tag="a" to="/results">Results</router-link>
					</div>
				</div>
			</div>
		</div>
	</nav>
	<aside class="menu" :class="{ 'is-active' : showNav }" v-else>
		<ul class="menu-list">
			<li>
				<div>
					<router-link tag="a" to="/next-events">Next Events</router-link>
				</div>
			</li>
			<li v-if="totalHorseEvents != 0">
				<div>
					<router-link tag="a" to="/categories/vip-horse">VIP Horse Racing <span class="num-events">{{ totalHorseEvents }}</span></router-link>
					<span class="fas fa-angle-down" @click="showHorseRacing = !showHorseRacing" :class="{ 'is-active' : showHorseRacing }"></span>
				</div>
				<ul :class="{ 'is-active' : showHorseRacing }">
					<li v-for="(meeting, key) in menuData.categories['vip-horse']['events']" :key="key">
						<div>
							<router-link tag="a" :to="'/categories/vip-horse/' + key">{{ meeting.name }}</router-link>
							<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
						</div>
						<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
							<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-horse/' + key + '/' + event.ID">
								<div>
									<a>{{ event.name }}</a>
								</div>
							</router-link>
						</ul>
					</li>
				</ul>
			</li>
			<li v-if="totalGreyhoundEvents != 0">
				<div>
					<router-link tag="a" to="/categories/vip-greyhound">VIP Greyhounds <span class="num-events">{{ totalGreyhoundEvents }}</span></router-link>
					<span class="fas fa-angle-down" @click="showGreyhounds = !showGreyhounds" :class="{ 'is-active' : showGreyhounds }"></span>
				</div>
				<ul :class="{ 'is-active' : showGreyhounds }">
					<li v-for="(meeting, key) in menuData.categories['vip-greyhound']['events']" :key="key">
						<div>
							<router-link tag="a" :to="'/categories/vip-greyhound/' + key">{{ meeting.name }}</router-link>
							<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
						</div>
						<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
							<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-greyhound/' + key + '/' + event.ID">
								<div>
									<a>{{ event.name }}</a>
								</div>
							</router-link>
						</ul>
					</li>
				</ul>
			</li>
			<li v-if="totalCyclingEvents != 0">
				<div>
					<router-link tag="a" to="/categories/vip-cycling">VIP Cycling <span class="num-events">{{ totalCyclingEvents }}</span></router-link>
					<span class="fas fa-angle-down" @click="showCycling = !showCycling" :class="{ 'is-active' : showCycling }"></span>
				</div>
				<ul :class="{ 'is-active' : showCycling }">
					<li v-for="(meeting, key) in menuData.categories['vip-cycling']['events']" :key="key">
						<div>
							<router-link tag="a"  :to="'/categories/vip-cycling/' + key">{{ meeting.name }}</router-link>
							<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
						</div>
						<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
							<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-cycling/' + key + '/' + event.ID">
								<div>
									<a>{{ event.name }}</a>
								</div>
							</router-link>
						</ul>
					</li>
				</ul>
			</li>
			<li v-if="totalMotorEvents != 0">
				<div>
					<router-link tag="a" to="/categories/vip-motor-racing">VIP Motor Racing <span class="num-events">{{ totalMotorEvents }}</span></router-link>
					<span class="fas fa-angle-down" @click="showMotorRacing = !showMotorRacing" :class="{ 'is-active' : showMotorRacing }"></span>
				</div>
				<ul :class="{ 'is-active' : showMotorRacing }">
					<li v-for="(meeting, key) in menuData.categories['vip-motor-racing']['events']" :key="key">
						<div>
							<router-link tag="a" :to="'/categories/vip-motor-racing/' + key">{{ meeting.name }}</router-link>
							<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
						</div>
						<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
							<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-motor-racing/' + key + '/' + event.ID">
								<div>
									<a>{{ event.name }}</a>
								</div>
							</router-link>
						</ul>
					</li>
				</ul>
			</li>
			<li v-if="totalSpeedwayEvents != 0">
				<div>
					<router-link tag="a" to="/categories/vip-speedway">VIP Speedway <span class="num-events">{{ totalSpeedwayEvents }}</span></router-link>
					<span class="fas fa-angle-down" @click="showSpeedway = !showSpeedway" :class="{ 'is-active' : showSpeedway }"></span>
				</div>
				<ul :class="{ 'is-active' : showSpeedway }">
					<li v-for="(meeting, key) in menuData.categories['vip-speedway']['events']" :key="key">
						<div>
							<router-link tag="a" :to="'/categories/vip-speedway/' + key">{{ meeting.name }}</router-link>
							<span class="fas fa-angle-down" @click="show(key)" :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }"></span>
						</div>
						<ul :class="{ 'is-active' : (typeof showMeetings[key] != 'undefined') }">
							<router-link tag="li" v-for="event in meeting.events" :key="event.ID" :to="'/categories/vip-speedway/' + key + '/' + event.ID">
								<div>
									<a>{{ event.name }}</a>
								</div>
							</router-link>
						</ul>
					</li>
				</ul>
			</li>
			<li>
				<div>
					<router-link tag="a" to="/results">Results</router-link>
				</div>
			</li>
		</ul>
	</aside>
</template>

<script>
import { eventBus } from '../../main';

export default {
	props: [ 'menuData' ],
	data() {
		return {
			localMenuData: this.menuData,
			showNav: !this.checkMobile(),
			showHorseRacing: false,
			showGreyhounds: false,
			showCycling: false,
			showMotorRacing: false,
			showSpeedway: false,
			showMeetings: {},
			useMobile: false,
			totalHorseEvents: 0,
			totalGreyhoundEvents: 0,
			totalCyclingEvents: 0,
			totalMotorEvents: 0,
			totalSpeedwayEvents: 0,
			updated: 0,
			appLoading: false
		}
	},
	watch: {
        '$route' (to, from) {
			if(this.checkMobile()) this.showNav = false;
        }
	},
	created() {
		eventBus.$on('appLoading', (value) => {
			this.appLoading = value;
		});

		eventBus.$on('loadMenu', () => {
			this.setMenu();
		});

		eventBus.$on('menuLoading', (data) => {
			this.localMenuData = data;
			this.$forceUpdate();
		});

		setInterval(() => {
			if(!this.appLoading) {
				this.setMenu(false);
			}
		}, 30000);
	},
	mounted() {
		this.setMenu();
	},
	methods: {
		totalEvents() {
			for(let category in this.menuData.categories) {
				let total = 0;

				for(var key in this.menuData.categories[category].events) {
					let meeting = this.menuData.categories[category].events[key];

					total += meeting.events.length;
				}

				switch(category) {
					case 'vip-horse':
						this.totalHorseEvents = total;
						break;
					case 'vip-greyhound':
						this.totalGreyhoundEvents = total;
						break;
					case 'vip-cycling':
						this.totalCyclingEvents = total;
						break;
					case 'vip-motor-racing':
						this.totalMotorEvents = total;
						break;
					case 'vip-speedway':
						this.totalSpeedwayEvents = total;
						break;
				}
			}
		},
		show(meetingID) {
			if(typeof this.showMeetings[meetingID] == 'undefined') {
				this.showMeetings[meetingID] = true;
			} else {
				delete this.showMeetings[meetingID];
			}

			this.$forceUpdate();
		},
		toUrl(str) {
			if(str == undefined) return '';
			let tmp = str.replace(/\s/g, '-');
			tmp = tmp.replace(/\//g, '_');
			tmp = tmp.toLowerCase();
			return tmp;
		},
		getWidth() {
			return Math.max(
				document.body.scrollWidth,
				document.documentElement.scrollWidth,
				document.body.offsetWidth,
				document.documentElement.offsetWidth,
				document.documentElement.clientWidth
			);
		},
		getHeight() {
			return Math.max(
				document.body.scrollHeight,
				document.documentElement.scrollHeight,
				document.body.offsetHeight,
				document.documentElement.offsetHeight,
				document.documentElement.clientHeight
			);
		},
		checkMobile () {
			if(this.getWidth() < 700) {
				eventBus.$emit('isMobile', true);
				return true;
			} else {
				eventBus.$emit('isMobile', false);
				return false;
			}
		},
		getTotalCategoryEvents(category) {
			let total = 0;

			for(var key in this.menuData.categories[category].events) {
				let meeting = this.menuData.categories[category].events[key];

				total += meeting.events.length;
			}

			return total;
		},
		compareEvents(a, b) {
			if(a.name < b.name) return -1;
			if(a.name > b.name) return 1;
			return 0;
		},
		setMenu(load = true) {
			if(load == true) eventBus.$emit('loading', ['Menu', true]);

			var _self = this;

			this.$API.GetMenu(this.menuData.updated, (response) => {
				if(response.status == 1) {
					if(response.result.update == false) {
						// Data hasn't changed, do nothing
						this.useMobile = this.checkMobile();

						window.addEventListener('resize', (event) => {
							this.useMobile = this.checkMobile();
						});

						eventBus.$emit('menuLoaded', [load, _self.menuData]);

						if(load == true) eventBus.$emit('loading', ['Menu', false]);
						return;
					}

					let tmp = _self.localMenuData;

					// Append new events
					
					for(let key in response.result.categories) {
						let category = response.result.categories[key];

						for(let k in tmp.categories) {
							let cat = tmp.categories[k];

							if(k == _self.toUrl(key)) {
								for(let e in category) {
									let event = category[e];
									let meetingID = event.meetingID;
									let meetingName = event.meetingName;

									if(!(meetingID in cat.events)) cat.events[meetingID] = {
										'name': meetingName,
										'events': []
									};

									let found = cat.events[meetingID].events.some((el) => {
										return el.ID === event.ID;
									});

									if(!found) cat.events[meetingID].events.push(event);

									cat.events[meetingID].events.sort(this.compareEvents);

									this.show[meetingID] = false;
								}
							}
						}
					}

					// Delete old events

					// for(let key in tmp.categories) {
					// 	let category = tmp.categories[key];

					// 	for(let k in response.result.categories) {
					// 		let cat = response.result.categories[k];

					// 		if(key == _self.toUrl(k)) {
					// 			for(let m in category.events) {
					// 				let meeting = category.events[m];

					// 				meeting.events.forEach((event, index) => {
					// 					if(!(event.ID in cat)) {
					// 						// This is an old event, delete it from tmp
					// 						tmp.categories[key].events[m].events.splice(index, 1);
					// 					}
					// 				});
					// 			}
					// 		}
					// 	}
					// }

					tmp.updated = response.result.updated;
					eventBus.$emit('menuLoaded', [load, tmp]);
				} else {
					console.error(response.result.error);
				}

				this.useMobile = this.checkMobile();

				window.addEventListener('resize', (event) => {
					this.useMobile = this.checkMobile();
				});

				this.totalEvents();
				this.$forceUpdate();

				if(load == true) eventBus.$emit('loading', ['Menu', false]);
			});
		}
	}
}
</script>

<style lang="less">
.fas.fa-angle-down {
	float: right;
	cursor: pointer;

	&::before {
		margin-top: 0.6em;
		margin-right: 15px;
		display: block;
	}
	&.is-active::before {
		transform: rotate(180deg);
	}
}

.navbar {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	max-height: 100%;
	overflow-y: auto;
	background-color: #808080;
	color: #fff;

	.num-events {
		padding: 2px 10px;
		margin-left: 5px;
		font-size: 12px;
		background-color: #8b0000;
		color: #fff;
	}
	
	.navbar-brand {
		border-bottom: 2px solid darken(rgba(56, 90, 102, 0.75), 15%);

		.navbar-burger {
			color: #fff;
		}
	}

	.navbar-menu.is-active {
		background-color: #808080 !important;
		padding: 0;
	}

	.navbar-menu .navbar-start {
		padding: 0;
		background-color: inherit;

		a {
			display: inline-block;
			color: #fff;

			&:hover {
				background-color: inherit;
				color: #F9D71E;
			}
		}

		.menu-item {
			div {
				padding: 10px;
				border-bottom: 2px solid darken(rgba(56, 90, 102, 0.75), 15%);
			}
			& > div .fas.fa-angle-down::before {
				margin-top: 0.4em;
			}

			ul {
				padding-left: 10px;
			}

			& > ul {
				display: none;

				.fas.fa-angle-down::before {
					margin-top: 0.3em;
				}

				&.is-active {
					display: block;
					margin: 0;
					border-left: none;
				}

				li {
					background-color: darken(#808080, 4%);
					border-left: 2px solid darken(rgba(56, 90, 102, 0.75), 15%);
					padding: 0;

					& > ul {
						display: none;

						&.is-active {
							display: block;
						}
					}

					& > ul li {
						background-color: darken(#808080, 8%);
						border-bottom: 2px solid darken(rgba(56, 90, 102, 0.75), 15%);

						div {
							border-bottom: 0;
						}
					}
				}
			}
		}
	}
}

aside.menu {
	position: fixed;
	top: 50px;
	left: 0;
	width: 300px;
	display: flex;
	flex-direction: row;
	height: 100%;
	background-color: #707070;
	color: #fff;
	padding-bottom: 50px;
	border-right: 2px solid darken(#707070, 15%);

	.num-events {
		padding: 2px 10px;
		margin-left: 5px;
		font-size: 12px;
		background-color: #8b0000;
		color: #fff;
	}

	.menu-list {
		flex-grow: 1;
		overflow-y: auto;
		display: none;

		li div {
			border-bottom: 2px solid darken(#707070, 15%);
		}

		& > li > div {
			padding: 5px;
		}

		a {
			display: inline-block;
			color: #fff;
			
			&:hover {
				background-color: inherit;
				color: #F9D71E;
			}
		}

		li > ul {
			display: none;

			&.is-active {
				display: block;
				margin: 0;
				border-left: none;
			}

			li {
				background-color: darken(#707070, 4%);
				border-left: 2px solid darken(#707070, 15%);
				padding: 0;

				& > ul li {
					background-color: darken(#707070, 8%);

					&:not(:first-child) {
						border-top: 2px solid darken(#707070, 15%);
					}

					&:not(:last-child) div {
						border-bottom: 0;
					}
				}
			}
		}
	}

	&.is-active {
		min-width: 15%;

		.navbar-brand .navbar-item {
			display: inline;
		}

		.menu-list {
			display: block;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Menu.vue